'use client';
import { useTheme } from "next-themes";
import Image, { ImageProps } from "next/image";
import { memo } from 'react';

type Props = Omit<ImageProps, 'src'> & { src: string; darkSrc?: string; eager?: boolean; fallbackSrc?: string; className?: string; };

const ThemedImage = ({ src, darkSrc = src, fallbackSrc, eager, ...rest }: Props) => {
  const { theme } = useTheme();

  //@ts-ignore
  ['loading', 'fill', 'sizes', 'priotiy'].forEach(x => delete rest[x]);

  return (
    <img
      {...rest}
      alt={rest.alt || ''}
      src={theme === 'dark' ? darkSrc : src} 
      loading={eager ? 'eager' : 'lazy'}
      fetchPriority={eager ? 'high' : 'low'}
    />
  )
}

export default memo(ThemedImage);